// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".player-game-name{display:inline-flex;align-items:center}.player-game-name__verify{margin-right:6px}.player-game-name__name{line-height:20px}.player-game-name__name.--pointer{cursor:pointer;font-weight:500;letter-spacing:.2px;font-size:17px}.player-game-name__name.--pointer:hover{text-decoration:underline}.player-game-name__name.--me{color:#00bcd4}.player-game-name>svg{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
